"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GlobalMarkupOptions = require("./GlobalMarkupOptions");

/**
 * Isomorphic breadcrumb setter
 * React hook for determining where to set breadcrumb options. Either
 * Server Side (with useGlobalMarkupOptions)
 *   OR
 * Client Side (with setHeaderProps)
 *
 * @param {object} breadcrumbOptions - Breadcrumbs options to be rendered on a page
 * NOTE: See https://github.com/NerdWallet/global-markup#v2-options for a list of breadcrumb options
 */
const useBreadcrumbs = breadcrumbOptions => {
  (0, _GlobalMarkupOptions.useGlobalMarkupOptions)({
    globalNavProps: {
      breadcrumbs: breadcrumbOptions
    }
  }); // CSR

  if (typeof window !== 'undefined') {
    var _window, _window$nerdwallet, _window$nerdwallet$ui;

    (_window = window) === null || _window === void 0 ? void 0 : (_window$nerdwallet = _window.nerdwallet) === null || _window$nerdwallet === void 0 ? void 0 : (_window$nerdwallet$ui = _window$nerdwallet.ui) === null || _window$nerdwallet$ui === void 0 ? void 0 : _window$nerdwallet$ui.setHeaderProps({
      breadcrumbs: breadcrumbOptions
    });
  }
};

var _default = useBreadcrumbs;
exports.default = _default;